import PropTypes from 'prop-types';
import React from 'react';
import { useIntl } from 'react-intl';
import { Icon } from 'xm-spark';

import classnames from 'classnames';

import { goToPlace } from 'utils/navigation';
import NavTooltip from '../NavTooltip';

import styles from './MainNavItem.module.scss';

const MainNavItem = ({ isSelected, isWideMode, item, menuId, selectItem }) => {
  const intl = useIntl();
  const { icon, IconComponent, id, subNav, textCode, to } = item;

  const activateNav = () => {
    if (subNav) {
      selectItem(isSelected ? null : item);
    } else if (to) {
      goToPlace(to);
      selectItem(null);
    }
  };
  const onClick = () => {
    activateNav();
  };

  const onKeyUp = event => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      activateNav();
    }
  };

  const name = intl.formatMessage({ id: textCode });

  return (
    <NavTooltip active={!isWideMode} tooltipContent={name}>
      <div
        role="button"
        tabIndex={0}
        aria-haspopup={!!subNav}
        aria-expanded={isSelected || undefined}
        key={item.id}
        className={classnames(styles.navItem, {
          [styles.open]: isSelected,
          [styles.active]: menuId === item.id,
          [styles.isWideMode]: isWideMode,
        })}
        onClick={onClick}
        onKeyUp={onKeyUp}
        title={isWideMode ? name : undefined}
        data-testid={`mainNav_item mainNav_item-${id}`}
        id={id}
      >
        {IconComponent ? (
          <IconComponent width="100%" height="100%" className={styles.icon} />
        ) : (
          <Icon type={icon} className={styles.icon} />
        )}
        <span className={styles.name}>{name}</span>
      </div>
    </NavTooltip>
  );
};

MainNavItem.displayName = 'MainNavItem';
MainNavItem.propTypes = {
  item: PropTypes.shape().isRequired,
  isSelected: PropTypes.bool.isRequired,
  isWideMode: PropTypes.bool.isRequired,
  selectItem: PropTypes.func.isRequired,
  menuId: PropTypes.string.isRequired,
};

export default MainNavItem;
